import {buildIntentsFromConfig} from '#core/utils/intent-factory.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {isMobile} from '#core/utils/context-utils.js';

import {ApplicationConfig} from '#core/config/application-config.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';
import {generateBorder} from '#core/application/modules/tiles/border/index.js';

import {MenusLinksLists} from '../menus-links-list.js';

import PALETTE_SCHEMA from './desktop-info-section.palette-schema.yaml';

class DesktopInfoSectionFeature extends AbstractVisualFeature {
    get enabled() {
        return !isMobile();
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const {desktopInfoSectionItems} = ApplicationConfig.config;

        return {
            GlobalLinks: {
                hide: !desktopInfoSectionItems || desktopInfoSectionItems.length === 0,
                links: buildIntentsFromConfig(desktopInfoSectionItems),
                linkMenu: {
                    regularContainer: {
                        style: {
                            ...resolveBackground(PALETTE.INFO_SECTION_BG),
                            ...generateBorder(PALETTE.INFO_SECTION_BORDER),
                            overflow: 'hidden', // needed for round corners
                        },
                    },
                    headerContainer: {
                        style: {
                            ...(PALETTE.INFO_SECTION_SHOW_HEADER_UNDERLINE
                                ? {
                                      borderWidth: '0 0 1px 0',
                                      borderColor: PALETTE.INFO_SECTION_HEADER_UNDERLINE_COLOR,
                                      borderStyle: 'solid',
                                  }
                                : {}),
                            ...resolveBackground(PALETTE.INFO_SECTION_HEADER_BG), // have to use resolveBackground
                            padding: '8px',
                            height: 40,
                            alignItems: 'center',
                        },
                    },
                    header: {
                        style: PALETTE.INFO_SECTION_HEADER_TEXT,
                    },
                    regularItem: {
                        unselected: {
                            style: {
                                base: {
                                    padding: '8px',
                                    _mobile_padding: '8px 8px 8px 16px',
                                    alignItems: 'center',
                                    minHeight: '40px',
                                    ...PALETTE.INFO_SECTION_ITEM.LIST_ITEM_TEXT,
                                    ...(PALETTE.INFO_SECTION_ITEM.LIST_ITEM_SHOW_SEPARATOR
                                        ? {
                                              _desktop_borderWidth: '0 0 1px 0',
                                              _mobile_borderWidth: '0 0 1px 0',
                                              borderColor: PALETTE.INFO_SECTION_ITEM.LIST_ITEM_SEPARATOR_COLOR,
                                              borderStyle: 'solid',
                                          }
                                        : {
                                              borderWidth: 0,
                                          }),
                                },
                            },
                        },
                        indicator: {
                            style: {
                                base: {
                                    height: 0,
                                    backgroundColor: 'transparent',
                                },
                            },
                        },
                    },
                    regularLabel: {
                        // keep it empty. All styles are inherited from regularItem.unselected.style.base
                        style: {
                            overflowWrap: 'anywhere',
                        },
                    },
                },
            },
        };
    }
}

new DesktopInfoSectionFeature(MenusLinksLists);
